import { authRoleAccess } from '../../auth/AuthRoleAccess'
import { lazy } from 'react'

const RestaurantMenu = lazy(() => import('./RestaurantMenu'))

const restaurantMenuRoutes = [
    {
        path: '/restaurant-menu',
        component: RestaurantMenu,
        auth: authRoleAccess.restaurantMenu,
    },
]

export default restaurantMenuRoutes
